import { useState } from 'react';
import { reduxForm, SubmissionError } from 'redux-form';

import { config } from 'app/config';
import { addPlate, updatePlate, getClientsDict } from 'services/payments-service';
import { getCategoriesList, getVehicleClassesList, getOptionsList, isNeedAddCurrentTariff } from 'services/types';
import { Button, themes, Popup2, ViolationsCnt } from 'libs/ui';
import { DictInput, ParkingFilter2, required, WhiteStyledField, Title, ErrorMsg, DatePeriod } from 'libs/form';
import { StyledButtonContainer } from './plate-form.styled';
import { useTranslation } from 'react-i18next';

const PlateForm = (props) => {
  const { error, destroy, refresh, setMessage, form, handleSubmit, close, type, clientId, id, initialValues, tariffs } = props;

  const { t } = useTranslation();
  const isAdd = type === 'addForm';
  const [blacklist, setBlacklist] = useState(initialValues.is_blocked === true);
  const needAddTariff = isNeedAddCurrentTariff(isAdd, initialValues?.tariff_id, tariffs);

  /**
   * after submit
   */
  const afterSubmit = () => {
    refresh();
    setMessage(isAdd ? t('messages.Сохранено успешно') : t('messages.Изменения сохранены'));
    setTimeout(() => {
      setMessage('');
    }, 3000);
    close();
    destroy(form);
  };

  /**
   * submit
   * @param {*} values
   * @returns
   */
  const submit = (values) => {
    //console.log('🚀 ~ submit ~ values:', values);
    // data
    const test = false;
    const out = { ...values };
    out.is_blocked = out.is_blocked === 'true' || out.is_blocked === true;
    // out.vehicle_category = blacklist ? null : out.vehicle_category ? parseInt(out.vehicle_category) : null;
    out.vehicle_category = out.vehicle_category ? parseInt(out.vehicle_category) : null;
    out.vehicle_class = out.vehicle_class ? parseInt(out.vehicle_class) : null;

    if (!out.client_id && clientId) {
      out.client_id = clientId;
    }
    if (!clientId && !out.client_id) {
      out.client_id = null;
      out.client_name = null;
    }
    // if (out.is_blocked) {
    //   out.start_at = null;
    //   out.end_at = null;
    // }

    if (!isAdd) {
      out.id = id;
    }
    if (test) {
      console.log('🚀 ~ submit ~ out:', out);
      return Promise.resolve();
    }

    // method
    const method = isAdd ? addPlate : updatePlate;
    return method(out)
      .then(() => {
        afterSubmit();
      })
      .catch((errors) => {
        console.log('🚀 ~ submit ~ errors:', errors);
        if (errors && errors.data) {
          throw new SubmissionError({
            _error: errors.data.type,
          });
        } else {
          throw new SubmissionError({
            _error: errors.message,
          });
        }
      });
  };

  const cancel = () => {
    close();
    destroy(form);
  };

  const getClients = (name) => {
    return getClientsDict({
      filter_params: { name },
      sort_params: [{ field_name: 'name', direction: 'asc' }],
      paging_params: { limit: 5, offset: 0 },
    });
  };

  let title = isAdd ? t('form.Добавить ГРЗ') : t('form.Изменить ГРЗ');
  if (!isAdd) {
    title += ' ' + initialValues.vehicle_plate;
  }
  // const dateDisabled = blacklist;
  // const categoryDisabled = blacklist;

  return (
    <Popup2 w={482} top={3}>
      <Title>{title}</Title>
      <form onSubmit={handleSubmit(submit)}>
        <ErrorMsg error={error} />
        <ParkingFilter2 />

        {!clientId && (
          <WhiteStyledField
            selectedName={initialValues.client_name}
            label={t('form.Клиент')}
            placeholder={t('form.Клиент')}
            type="autocomplete2"
            name="client_id"
            getList={getClients}
          />
        )}

        {isAdd && <WhiteStyledField type="text" label={t('sections.ГРЗ') + config.req} placeholder={t('form.А000AA 000 rus')} name="mean_id" validate={required(t)} />}
        <WhiteStyledField type="text" label={t('form.Инициатор') + config.req} placeholder={t('form.Введите текст')} name="owner" validate={required(t)} />
        <WhiteStyledField type="text" label={t('form.Причина внесения') + config.req} placeholder={t('form.Введите текст')} name="comment" validate={required(t)} />

        <WhiteStyledField type="select" label={t('dict_filter.Класс ТС')} name="vehicle_class">
          <option value={null}>{t('form.Не задано')}</option>
          {getVehicleClassesList()}
        </WhiteStyledField>

        <WhiteStyledField type="select" label={t('form.Категория')} name="vehicle_category" /*disabled={categoryDisabled}*/>
          <option value="">{t('form.Не задано')}</option>
          {getCategoriesList()}
        </WhiteStyledField>

        <DatePeriod />

        <DictInput dict="plates.list" onChange={(event) => setBlacklist(event.target.value === 'true')} />

        <WhiteStyledField className="shortfield" type="select" label="Тариф" name="tariff_id">
          <option value="">{t('form.Не задано')}</option>
          {needAddTariff && <option value={initialValues?.tariff_id}>{initialValues?.tariff} (а)</option>}
          {getOptionsList(tariffs)}
        </WhiteStyledField>

        {!isAdd && <ViolationsCnt vehicle_plate={initialValues.vehicle_plate} cnt={initialValues.data?.violations_count} refresh={refresh} />}

        <StyledButtonContainer space="20px">
          <Button type="button" onClick={cancel}>
            {t('buttons.Отменить')}
          </Button>
          <Button theme={themes.blue}>
            <i className="fa fa-save" />
            {t('buttons.Сохранить')}
          </Button>
        </StyledButtonContainer>
      </form>
    </Popup2>
  );
};

export default reduxForm({
  form: 'clientPlateForm',
  destroyOnUnmount: false,
})(PlateForm);
